const getClosestDivisible = (num: number, min: number, max: number): number => {
  if (num < min) return min;

  if (num > max) return max;

  if (num % 500 === 0) return num;

  let lower = num - (num % 500);
  let upper = lower + 500;

  if (lower < min) lower = min;
  if (upper > max) upper = max;

  return num - lower < upper - num ? lower : upper;
};

export default getClosestDivisible;
